var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCircleArrow = function SvgCircleArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 49,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 24.5,
    r: 24.5,
    fill: "#137170",
    transform: "rotate(-180 25 24.5)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M38.5607 25.0607c.5857-.5858.5857-1.5356 0-2.1214l-9.546-9.5459c-.5858-.5858-1.5355-.5858-2.1213 0-.5858.5858-.5858 1.5355 0 2.1213L35.3787 24l-8.4853 8.4853c-.5858.5858-.5858 1.5355 0 2.1213.5858.5858 1.5355.5858 2.1213 0l9.546-9.5459ZM11.5 25.5h26v-3h-26v3Z"
  })));
};
export default SvgCircleArrow;